export type LinkItem = {
  id: string;
  title: string;
  icon?: string; // Optional icon name for the section
  onClick?: () => void;
}

export const DASHBOARD_SECTIONS: LinkItem[] = [
  {
    id: "features-section",
    title: "Features",
  },
  {
    id: "how-it-works-section",
    title: "How it Works",
    icon: "rooms",
  },
  {
    id: "key-benefits-section",
    title: "Solutions",
  },
  {
    id: "pricing-section",
    title: "Pricing",
  },
  {
    id: "our-vision-section",
    title: "About Us",
  },
  {
    id: "faq-section",
    title: "FAQ",
  }
];
